import { useCallback, useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import SidePanel from 'src/components/design-system/SidePanel';
import { handlePostMessage } from 'src/hooks/usePostMessage';
import useWindowSize from 'src/hooks/useWindowSize';
import RecommendationItems from 'src/sections/recommended_items/RecommendationItems';
import { RecommendPageParams } from 'src/types/recommendation_items/Recommendation';

interface RecommendedSidePanelProps {
  isInternal: boolean;
  isOpenSidePanel?: boolean;
  onCloseSidePanel?: (value: boolean) => void;
  dataParams?: RecommendPageParams | null;
}
const ViewRecommendedItems = ({
  isInternal,
  dataParams,
  isOpenSidePanel,
  onCloseSidePanel,
}: RecommendedSidePanelProps) => {
  const [isOpen, setIsOpen] = useState(isOpenSidePanel ?? true);
  const { width: viewportWidth } = useWindowSize();

  const sidePanelWidth = viewportWidth >= 768 ? '600px' : '100%';

  useEffect(() => {
    setIsOpen(isOpenSidePanel ?? true);
  }, [isOpenSidePanel]);

  const handleClose = useCallback(
    (pageRefresh: boolean = false) => {
      setIsOpen(false);
      onCloseSidePanel?.(false);
      const baseParams = {
        swapUiClosed: {
          pageRefresh,
        },
      };
      handlePostMessage(baseParams);
    },
    [onCloseSidePanel]
  );

  if (isInternal) {
    return (
      <SidePanel
        isOpen={isOpen}
        onClose={() => {}}
        closeOnEsc={false}
        width={sidePanelWidth}
        position="right"
        className="bg-[#F1F1F1]"
        fullHeight
      >
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <RecommendationItems
            isInternal={isInternal}
            onClose={handleClose}
            dataParams={dataParams}
          />
        </div>
        <Tooltip
          id={'recommended-panel-tooltip'}
          style={{
            backgroundColor: 'black',
            color: 'white',
            zIndex: 99999,
            maxWidth: '80%',
            wordWrap: 'break-word',
          }}
          place="bottom"
        />
      </SidePanel>
    );
  }

  // External: render as full page with SidePanel-style header
  return (
    <div>
      {isOpen && (
        <div className="flex h-screen min-h-0 flex-col overflow-hidden bg-[#F1F1F1]">
          <RecommendationItems isInternal={isInternal} onClose={handleClose} />
        </div>
      )}
      <Tooltip
        id={'recommended-panel-tooltip'}
        style={{
          backgroundColor: 'black',
          color: 'white',
          zIndex: 99999,
          maxWidth: '80%',
          wordWrap: 'break-word',
        }}
        place="bottom"
      />
    </div>
  );
};

export default ViewRecommendedItems;
